import { AccessoriesSizeTable } from '@components/AccessoriesSizeTable/AccessoriesSizeTable'
import { ModalSeparator } from '@components/ShoeSizeGuide/ShoeSizeGuide.styles'
import { SizeGuideHeader } from '@components/SizeGuideHeader/SizeGuideHeader'
import { SizeGuideModalFooter } from '@components/SizeGuideModalFooter/SizeGuideModalFooter'
import type { AccessoriesSizeGuideJson } from '@velasca/types'
import { SansText } from '@velasca/ui/sans-text'
import { SansTitle } from '@velasca/ui/sans-title'
import { AccessoriesDescriptionWrap } from './AccessoriesSizeGuide.styles'

export const AccessoriesSizeGuide = ({
  defaultMeasurementSystem,
  translations,
  sizeGuide,
}: AccessoriesSizeGuideJson) => {
  const {
    topTitle,
    localizedSizesLabel,
    firstButtonText,
    secondButtonText,
    footerTitle,
    footerText,
  } = translations

  const {
    sizeGuideId,
    sizeTitle01,
    sizeDescription01,
    sizeTitle02,
    sizeDescription02,
    localizedMeasure,
    table,
  } = sizeGuide

  return (
    <>
      {sizeGuideId && (
        <>
          <SizeGuideHeader title={topTitle} upperTitle={sizeTitle01} />

          {(sizeDescription01 || sizeDescription02) && (
            <AccessoriesDescriptionWrap>
              {sizeDescription01 && (
                <SansText center as="div">
                  {sizeDescription01}
                </SansText>
              )}

              {sizeDescription01 && sizeDescription02 && <ModalSeparator />}

              {sizeTitle02 && (
                <SansTitle
                  center
                  as="h3"
                  fontWeight="500"
                  size="sm"
                  color="primary"
                  margin="0 0 2rem"
                >
                  {sizeTitle02}
                </SansTitle>
              )}
              {sizeDescription02 && (
                <SansText center as="div">
                  {sizeDescription02}
                </SansText>
              )}
            </AccessoriesDescriptionWrap>
          )}

          <AccessoriesSizeTable
            convertible={sizeGuideId.includes('cinture')}
            sizeGuideId={sizeGuideId}
            table={table}
            localizedSizesLabel={localizedSizesLabel}
            localizedMeasure={localizedMeasure}
            firstButtonText={firstButtonText}
            secondButtonText={secondButtonText}
            defaultMeasurementSystem={defaultMeasurementSystem}
          />
        </>
      )}
      <SizeGuideModalFooter title={footerTitle} text={footerText} />
    </>
  )
}
